import { render, staticRenderFns } from "./HistoryCalling.vue?vue&type=template&id=9cdea55a&scoped=true"
import script from "./HistoryCalling.vue?vue&type=script&lang=js"
export * from "./HistoryCalling.vue?vue&type=script&lang=js"
import style0 from "./HistoryCalling.vue?vue&type=style&index=0&id=9cdea55a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdea55a",
  null
  
)

export default component.exports